import * as React from 'react';

import { Card } from '../../components/Card';
import { BookButtonContainer } from '../BookButtonContainer';
import { BrandingBannerContainer } from '../BrandingBannerContainer';
import { CarouselContainer } from '../CarouselContainer';
import { FavoritesContainer } from '../FavoritesContainer';
import { LabelsContainer } from '../LabelsContainer';
import { OfferGeneralInfoContainer } from '../OfferGeneralInfoContainer';
import { ThumbnailsContainer } from '../ThumbnailsContainer';
import { useOfferContext } from '../OfferContext';
import { CardActionsContainer } from '../CardActionsContainer';
import { TabletCardActionsContainer } from '../TabletCardActionsContainer';

interface IOfferCardContainerProps {
  onClick?: VoidFunction;
}

export function OfferCardContainer({ onClick }: IOfferCardContainerProps) {
  const { isCianPartner, id, isPromoted, href, brandingBannerShown, isFromDeveloper } = useOfferContext();
  const card = React.useRef<HTMLDivElement>(null);

  const { favorite, actionButtonDesktop, actionButtonPhone } = React.useMemo(
    () =>
      isCianPartner
        ? {
            favorite: null,
            actionButtonDesktop: <BookButtonContainer />,
            actionButtonPhone: <BookButtonContainer />,
          }
        : {
            favorite: <FavoritesContainer id={id} />,
            actionButtonDesktop: <TabletCardActionsContainer />,
            actionButtonPhone: <CardActionsContainer />,
          },
    [id, isCianPartner],
  );

  //TODO: архитектура карточки очень сильно переплетена, надо разобрать
  return (
    <Card
      brandingBanner={(brandingBannerShown || isFromDeveloper) && <BrandingBannerContainer />}
      content={<OfferGeneralInfoContainer />}
      favorite={favorite}
      gallery={<CarouselContainer />}
      href={href}
      actionButtonPhone={actionButtonPhone}
      labels={<LabelsContainer href={href} />}
      promoted={isPromoted}
      ref={card}
      actionButtonDesktop={actionButtonDesktop}
      thumbnails={<ThumbnailsContainer />}
      onClick={onClick}
    />
  );
}
